import React from 'react';

const ErrorIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'>
      <g fill='none' fill-rule='evenodd'>
        <g>
          <path
            stroke='var(--theme-primary, #810ea9)'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='5'
            d='M58.998 34.684v-6.961l15.26 13.413-15.26 13.529v-6.962H53.14s-7.413-.464-8.328 6.196c-.036.463-.036.929 0 1.392v10.744c.08 2.13-1.164 4.081-3.11 4.882-1.948.8-4.18.277-5.584-1.308l-.229-.255c-.793-.919-1.232-2.097-1.235-3.319V46.287s-.206-6.288 4.393-9.166c.948-.61 2.005-1.028 3.111-1.23.823-.154 1.657-.232 2.494-.232'
          />
          <circle cx='53.465' cy='35.644' r='1.98' fill='var(--theme-primary, #810ea9)' fill-rule='nonzero' />
          <path
            stroke='var(--theme-primary, #810ea9)'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='5'
            d='M12.442 37.834L38.43 11.845c6.528-6.528 17.112-6.528 23.64 0L88.06 37.834c6.528 6.528 6.528 17.112 0 23.64L62.07 87.462c-6.528 6.528-17.112 6.528-23.64 0L12.442 61.474c-6.528-6.528-6.528-17.112 0-23.64z'
          />
        </g>
      </g>
    </svg>
  );
};

export default ErrorIcon;
